import React from "react";

const CrossIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_264_1573"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_264_1573)">
        <path
          d="M10.0013 11.166L12.418 13.5827C12.5707 13.7355 12.7652 13.8118 13.0013 13.8118C13.2374 13.8118 13.4319 13.7355 13.5846 13.5827C13.7374 13.4299 13.8138 13.2355 13.8138 12.9993C13.8138 12.7632 13.7374 12.5688 13.5846 12.416L11.168 9.99935L13.5846 7.58268C13.7374 7.4299 13.8138 7.23546 13.8138 6.99935C13.8138 6.76324 13.7374 6.56879 13.5846 6.41602C13.4319 6.26324 13.2374 6.18685 13.0013 6.18685C12.7652 6.18685 12.5707 6.26324 12.418 6.41602L10.0013 8.83268L7.58463 6.41602C7.43186 6.26324 7.23741 6.18685 7.0013 6.18685C6.76519 6.18685 6.57075 6.26324 6.41797 6.41602C6.26519 6.56879 6.1888 6.76324 6.1888 6.99935C6.1888 7.23546 6.26519 7.4299 6.41797 7.58268L8.83463 9.99935L6.41797 12.416C6.26519 12.5688 6.1888 12.7632 6.1888 12.9993C6.1888 13.2355 6.26519 13.4299 6.41797 13.5827C6.57075 13.7355 6.76519 13.8118 7.0013 13.8118C7.23741 13.8118 7.43186 13.7355 7.58463 13.5827L10.0013 11.166ZM10.0013 18.3327C8.84852 18.3327 7.76519 18.1139 6.7513 17.6764C5.73741 17.2389 4.85547 16.6452 4.10547 15.8952C3.35547 15.1452 2.76172 14.2632 2.32422 13.2493C1.88672 12.2355 1.66797 11.1521 1.66797 9.99935C1.66797 8.84657 1.88672 7.76324 2.32422 6.74935C2.76172 5.73546 3.35547 4.85352 4.10547 4.10352C4.85547 3.35352 5.73741 2.75977 6.7513 2.32227C7.76519 1.88477 8.84852 1.66602 10.0013 1.66602C11.1541 1.66602 12.2374 1.88477 13.2513 2.32227C14.2652 2.75977 15.1471 3.35352 15.8971 4.10352C16.6471 4.85352 17.2409 5.73546 17.6784 6.74935C18.1159 7.76324 18.3346 8.84657 18.3346 9.99935C18.3346 11.1521 18.1159 12.2355 17.6784 13.2493C17.2409 14.2632 16.6471 15.1452 15.8971 15.8952C15.1471 16.6452 14.2652 17.2389 13.2513 17.6764C12.2374 18.1139 11.1541 18.3327 10.0013 18.3327Z"
          fill="#121C27"
        />
      </g>
    </svg>
  );
};

export default CrossIcon;
